import React, { useEffect, useState } from "react";
import styled from "styled-components";

import ModalEnabled from "../../../../../components/modalComponents/ModalEnabled";
import PageHeader from "../../../../../components/pageHeader/PageHeader";
import SearchContainer from "../../../../../components/pageComponents/SearchContainer";
import PageButtons from "../../../../../components/pageComponents/PageButtons";
import PageWrapper from "../../../../../components/pageComponents/PageWrapper";

import { useGetRequest } from "../../../../../hooks/useGetRequest/useGetRequest";
import { useManagePostRequest } from "../../../../../hooks/useManagePostRequest/useManagePostRequest";
import useDidMountEffect from "../../../../../hooks/useDidMountEffect/useDidMountEffect";



import {
  initialAllOptionPromises,
  jsonNoEstaVacio,
  updateFiltersWithExtraData,
} from "../../../../../helper/utils";

import {
  cuadroRequerimientosGetCasosListado,
  cuadroRequerimientosGetFiltrosTipos,
  cuadroRequerimientosGetFiltrosEstados, 
} from "../../../../../consumers/backendApisUrls";

import { INIT_KEYS } from "./modales/casoKeys";
import TableGestorCasos from "./TableGestorCasos";
import NuevoCasoModal from "./modales/NuevoCasoModal";

const INIT_KEYS_LIST = [INIT_KEYS.IdsTiposCaso, INIT_KEYS.IdsEstados];

export default function CuadroRequerimientosComentarios({ idCuadroSede }) {
  const [formValues, setFormValues] = useState({
    Items: [],
    ExtraData: {},
    filters: [],
    selectedFilters: {},
  });
  const [allFilters, setAllFilters] = useState([]);

  const [puedeCrearCaso, setPuedeCrearCaso] = useState(false);

  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({ CurrentPage: 1 });
  const [isLoading, setIsLoading] = useState(true);
  const [modalEnabled, setModalEnabled] = useState({
    isEnable: false,
    component: React.Fragment,
  });

  const [executeGet] = useGetRequest();
  const [executeManagePost] = useManagePostRequest();

  const initialPromises = () => [
    executeGet(cuadroRequerimientosGetFiltrosTipos()),
    executeGet(cuadroRequerimientosGetFiltrosEstados()),
  ];

  const init = async () => {
    setIsLoading(true);
    try {
      await manageSearch();
      await initialAllOptionPromises(
        initialPromises,
        INIT_KEYS_LIST,
        setAllFilters,
      );
      if (formValues.filters.length === 0) {
        jsonNoEstaVacio(formValues.ExtraData) &&
          updateFiltersWithExtraData(
            allFilters,
            formValues.ExtraData,
            handleUpdatedFilters,
          );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const manageSearch = async () => {
    setIsLoading(true);
    const api = cuadroRequerimientosGetCasosListado();
    const payload = getPayload();
    await executeManagePost(api, payload, successManageSearchCallback);
    setIsLoading(false);
  };

  const getPayload = () => ({
    Criteria: searchCriteria,
    Page: paginator.CurrentPage,
    IdCuadroSede: Number(idCuadroSede),
    ...formValues.selectedFilters,
  });

  const successManageSearchCallback = ({ data }) => {
 
    const {
      Items,
      ExtraData,
      TotalItems,
      FirsItemPage,
      LastItemPage,
      TotalPages,
      CurrentPage,
    } = data;
    console.log(Items);
    setFormValues((last) => ({ ...last, Items, ExtraData }));
    setPaginator({
      TotalItems,
      FirsItemPage,
      LastItemPage,
      TotalPages,
      CurrentPage,
    });
    setIsLoading(false);
    setPuedeCrearCaso(data?.PuedeCrearCaso ?? false)
  };

  const handleUpdatedFilters = (res) => {
    setFormValues((last) => ({ ...last, filters: res }));
  };

  const handleCleanSearch = () => {
    setFormValues({ ...formValues, selectedFilters: null });
  };

  useEffect(() => {
    init();
  }, []);

  useDidMountEffect(() => {
    jsonNoEstaVacio(formValues.ExtraData) &&
      updateFiltersWithExtraData(
        allFilters,
        formValues.ExtraData,
        handleUpdatedFilters,
      );
  }, [formValues.ExtraData]);

  useDidMountEffect(() => {
    manageSearch();
  }, [paginator.CurrentPage, formValues.selectedFilters]);

  return (
    <PageWrapper>
      <ModalEnabled
        modalEnabled={modalEnabled}
        setModalEnabled={setModalEnabled}
        refreshPage={manageSearch}
      />
      <PageHeader title="Gestor de Casos" />
      <SearchContainer
        searchCriteria={searchCriteria}
        setSearchCriteria={setSearchCriteria}
        setPaginator={setPaginator}
        manageSearch={manageSearch}
        addCleanSearch={handleCleanSearch}
      >
        <ButtonsWrapper>
          <div className="d-flex">
            <PageButtons>
                {puedeCrearCaso &&
                    <button
                        type="button"
                        className="generic-button-buscador"
                        onClick={() =>
                            setModalEnabled({
                                isEnable: true,
                                component: NuevoCasoModal,
                                data: {
                                    idCuadroSede: Number(idCuadroSede),
                                    refreshPage: manageSearch,
                                },
                            })
                        }
                    >
                        Agregar
                    </button>
                }
            </PageButtons>
          </div>
        </ButtonsWrapper>
      </SearchContainer>

      <TableGestorCasos
        formValues={formValues}
        setFormValues={setFormValues}
        extraData={formValues.ExtraData}
        setModalEnabled={setModalEnabled}
        paginator={paginator}
        setPaginator={setPaginator}
        keys={INIT_KEYS}
        manageSearch={manageSearch}
        idCuadroSede = {idCuadroSede}
      />

    </PageWrapper>
  );
}
const ButtonsWrapper = styled.div`
  display: block;
  @media (max-width: 796px) {
    display: none;
  }
`;

